

import React, { useRef } from 'react';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';

const testimonials = [
  {
    quote: "Codemine helped me ace my web dev course. I built a complex project visually that would have taken me weeks to code. It's an incredible learning tool!",
    name: 'Ali Raza',
    location: 'Student, Karachi'
  },
  {
    quote: "As a startup founder, speed is everything. Codemine let us prototype and deploy a functional MVP in a single weekend. Game-changing.",
    name: 'Jonathan Doe',
    location: 'Developer, San Francisco'
  },
  {
    quote: "We launched our online bakery, 'Lahore Bakes', in days thanks to Codemine. It's incredibly powerful for entrepreneurs who aren't tech experts.",
    name: 'Fatima Saad',
    location: 'Co-founder, Lahore Bakes'
  },
  {
    quote: "I used Codemine to build the booking website for my consultancy. The ability to just describe changes and see them happen is magical. Saved me thousands in developer fees.",
    name: 'Emily Carter',
    location: 'Founder, Carter Consulting, London'
  },
  {
    quote: "This tool is not just for beginners. It handles the repetitive setup, so I can focus on writing the unique logic that matters. It has easily doubled my productivity.",
    name: 'Sameer Khan',
    location: 'Software Engineer, Islamabad'
  },
  {
    quote: "From a napkin sketch to a live landing page in an afternoon. The iteration process is fantastic; you can just tell the AI to make changes. Highly recommended!",
    name: 'Mariam Choudry',
    location: 'Entrepreneur, Sialkot'
  },
];

const TestimonialCard: React.FC<{ quote: string; name: string; location: string }> = ({ quote, name, location }) => (
  <div className="glow-card relative flex-shrink-0 w-80 md:w-96 p-8 mx-4 bg-[var(--panel-bg)] border border-[var(--border-color)] rounded-xl shadow-lg overflow-hidden">
    <div className="relative z-10">
      <div className="text-yellow-400 text-2xl mb-4">★★★★★</div>
      <blockquote className="text-[var(--text-primary)] italic mb-6">"{quote}"</blockquote>
      <div className="mt-4 text-right">
        <p className="font-bold text-[var(--text-primary)]">{name}</p>
        <p className="text-sm text-[var(--text-secondary)]">{location}</p>
      </div>
    </div>
  </div>
);

const Testimonials: React.FC = () => {
    const sectionRef = useRef<HTMLDivElement>(null);
    const isVisible = useIntersectionObserver(sectionRef, { threshold: 0.1 });
    const duplicatedTestimonials = [...testimonials, ...testimonials];

  return (
    <section id="ai-agents" ref={sectionRef} className={`py-20 sm:py-32 overflow-hidden transition-all duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-extrabold text-[var(--text-primary)]">Trusted by Innovators Across The World</h2>
          <p className="mt-4 max-w-2xl mx-auto text-lg text-[var(--text-secondary)]">From students to entrepreneurs, see how Codemine is empowering creators.</p>
        </div>

        <div className="w-full inline-flex flex-nowrap overflow-hidden [mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-128px),transparent_100%)]">
            <div className="flex items-center justify-center md:justify-start [&_div]:mx-4 animate-scroll hover:[animation-play-state:paused]">
                {duplicatedTestimonials.map((testimonial, index) => (
                    <TestimonialCard key={index} {...testimonial} />
                ))}
            </div>
      </div>
    </section>
  );
};

export default Testimonials;